// extracted by mini-css-extract-plugin
export var root = "ContentWrapper-module--root--s6dwU";